import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import {
  FilterBuilderModel,
  FilterConfigPayload,
  ToggleAIInsightsPayload,
  ToggleFiltersPayload,
} from '../../models/filter.model';
import { DATASET_INITIAL_ID } from '../../../common/constants';

// identifier
export const FILTER_BUILDER_SLICE_ID = 'filterBuilder';

// default state
const initialState: FilterBuilderModel = {};

//slice
const filterBuilderSlice = createSlice({
  name: FILTER_BUILDER_SLICE_ID,
  initialState,
  reducers: {
    setFilters: (state: FilterBuilderModel, action: PayloadAction<FilterConfigPayload>): void => {
      const { datasetId = DATASET_INITIAL_ID, filters } = action.payload;
      let filterSet = state[datasetId];
      if (!filterSet) {
        filterSet = { visible: false, filters: [], customFilters: [] };
      }
      filterSet.filters = filters;

      state[datasetId] = filterSet;
    },
    toggleFilters: (
      state: FilterBuilderModel,
      action: PayloadAction<Partial<ToggleFiltersPayload>>
    ): void => {
      if (typeof action.payload.visible !== 'undefined') {
        const { datasetId = DATASET_INITIAL_ID, visible } = action.payload;
        if (!state[datasetId]) {
          state[datasetId] = { visible: false, filters: [], customFilters: [] };
        }
        state[datasetId].visible = visible;
      }
    },
    toggleAIInsights: (
      state: FilterBuilderModel,
      action: PayloadAction<ToggleAIInsightsPayload>
    ): void => {
      const { datasetId = DATASET_INITIAL_ID, visible } = action.payload;
      if (!state[datasetId]) {
        state[datasetId] = {
          visible: false,
          filters: [],
          customFilters: [],
          hideAIInsights: !visible,
        };
      }
      state[datasetId].hideAIInsights = !visible;
    },
  },
});

//selectors
export const selectDisplayFilters = (state: RootState, datasetId: string) => {
  const filter = state.filterBuilder[datasetId];
  if (filter) {
    return filter.filters;
  }
  return null;
};

export const selectFiltersVisible = (state: RootState, datasetId: string) => {
  const filter = state.filterBuilder[datasetId];
  if (filter) {
    return filter.visible;
  }
  return null;
};

export const selectFilterViewVisible = (state: RootState, datasetId: string) => {
  const filter = state.filterBuilder[datasetId];
  if (filter) {
    return filter.visible;
  }
  return null;
};

export const selectAIInsightsVisible = (state: RootState, datasetId: string) => {
  const filter = state.filterBuilder[datasetId];
  if (filter) {
    return !filter.hideAIInsights;
  }
  return null;
};

//actions
export const { setFilters, toggleFilters, toggleAIInsights } = filterBuilderSlice.actions;

//reducer
export default filterBuilderSlice;
